import { render, staticRenderFns } from "./TemplateSelector.vue?vue&type=template&id=2d66844c"
import script from "./TemplateSelector.vue?vue&type=script&lang=js"
export * from "./TemplateSelector.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelector.vue?vue&type=style&index=0&id=2d66844c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports